module.exports = __webpack_public_path__ + "img/carshina21_10.d09ac8a1.jpg";